import { createSelector } from '@ngrx/store';
import { UserData } from '../reducers/user.reducers';
import { SharedAppState } from '../app.states';

export const selectMeFromReducer = createSelector(
    (state: SharedAppState) => state.user,
    (userState: UserData) => ({
        me: userState.me,
    })
);

export const selectCurrentUser = createSelector(
    (state: SharedAppState) => state.user,
    (userState: UserData) => userState.me
);
